import { useState, useEffect, useRef } from 'react';
import TouchAppIcon from '@mui/icons-material/TouchApp';

interface IQuestionMediaProps {
  media?: string;
  mediaAltText?: string;
}

const QuestionMedia = ({ media, mediaAltText = '' }: IQuestionMediaProps) => {
  const [isBlurred, setIsBlurred] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      if (!isBlurred) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [isBlurred]);

  if (!media) return null;

  const handleBlurToggle = () => {
    setIsBlurred(false);
  };

  return (
    <div
      className="bp-relative bp-mt-4 bp-max-h-36 bp-max-w-36 bp-cursor-pointer"
      onClick={handleBlurToggle}
    >
      {media.split('.').pop() === 'mp4' ? (
        <video
          ref={videoRef}
          className={`bp-h-full bp-w-full ${isBlurred ? 'bp-opacity-30 bp-blur-[10px]' : ''}`}
          controls
          muted
        >
          <source src={media} type="video/mp4" />
        </video>
      ) : (
        <img
          className={`bp-h-full bp-w-full ${isBlurred ? 'bp-opacity-30 bp-blur-[10px]' : ''}`}
          src={media}
          alt={mediaAltText}
        />
      )}
      {isBlurred && (
        <div className="bp-absolute bp-left-0 bp-top-0 bp-flex bp-h-full bp-w-full bp-flex-col bp-items-center bp-justify-center bp-bg-white/50">
          <TouchAppIcon color="primary" />
          <span className="bp-mt-1 bp-font-primary bp-text-xxs bp-text-primary-main">
            Click to View
          </span>
        </div>
      )}
    </div>
  );
};

export default QuestionMedia;
